module.exports = "<i class=\"{{icon}}\" data-id=\"{{id}}\"></i>\n<span class=\"badge\">{{draft_or_deployment}}</span>"